import script from "./SimulateFassetsThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulateFassetsThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./SimulateFassetsThumbnail.vue?vue&type=style&index=0&id=64fbdd60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fbdd60"]])

export default __exports__